import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { TripInvitesByTripOrBookingQuery } from '../gql/graphql';

const tripInvitesByTripOrBookingQuery = graphql(/* GraphQL */ `
  query tripInvitesByTripOrBooking($tripId: Int, $bookingId: Int) {
    tripInvite(tripId: $tripId, bookingId: $bookingId) {
      inviteId
      tripId
      bookingId
      email
      magicLink
      isCompleted
      inviteStatus
    }
  }
`);

const useTripInvites = (
  params: { tripId?: number; bookingId?: number },
  shouldFetch: boolean,
) => {
  const { tripId, bookingId } = params;
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const queryKey = ['tripInvites', tripId, bookingId];

  const queryFn = async () => {
    return graphqlRequest<TripInvitesByTripOrBookingQuery>(
      tripInvitesByTripOrBookingQuery,
      {
        tripId,
        bookingId,
      },
      isAuthenticated ? getAccessTokenSilently : undefined,
    );
  };

  const { data, isLoading, error } = useQuery<TripInvitesByTripOrBookingQuery>({
    queryKey,
    queryFn,
    enabled: !!shouldFetch && !!(tripId || bookingId) && isAuthenticated,
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    tripInvites: data?.tripInvite || [],
    isLoading,
    error,
  };
};

export default useTripInvites;
